'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  feature: string;
  parkping: boolean | string;
  traditional: boolean | string;
}

interface ComparisonTableProps {
  features: ComparisonFeature[];
}

export default function ComparisonTable({ features }: ComparisonTableProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return (
        <div className="flex items-center justify-center">
          {value ? (
            <Icon name="CheckCircleIcon" size={28} className="text-[#42AF47]" />
          ) : (
            <Icon name="XCircleIcon" size={28} className="text-gray-400" />
          )}
        </div>
      );
    }
    return (
      <div className="flex items-center justify-center">
        <span className="text-gray-900 font-medium">{value}</span>
      </div>
    );
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-gray-900 mb-4">
            Why Choose ParkPing?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See how we compare to traditional parking solutions
          </p>
        </div>

        <div className="flex justify-center">
          <div className="w-full max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
            <div className="overflow-x-auto">
              <table className="w-full">
              <thead>
                <tr className="bg-[#42AF47] text-white">
                  <th className="px-6 py-5 text-left font-heading font-bold text-lg">
                    Feature
                  </th>
                  <th className="px-6 py-5 text-center font-heading font-bold text-lg">
                    <div className="flex items-center justify-center space-x-2">
                      <Icon name="SparklesIcon" size={24} className="text-white" />
                      <span>ParkPing</span>
                    </div>
                  </th>
                  <th className="px-6 py-5 text-center font-heading font-bold text-lg">
                    Traditional Methods
                  </th>
                </tr>
              </thead>
              <tbody>
                {features.map((item, index) => (
                  <tr
                    key={index}
                    className={`border-b border-gray-100 ${
                      index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                    } hover:bg-gray-50 transition-colors duration-200`}
                  >
                    <td className="px-6 py-5 font-medium text-gray-900">
                      {item.feature}
                    </td>
                    <td className="px-6 py-5 text-center">{renderValue(item.parkping)}</td>
                    <td className="px-6 py-5 text-center">{renderValue(item.traditional)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <button className="px-8 py-4 bg-[#42AF47] text-white font-heading font-semibold rounded-lg shadow-lg hover:shadow-xl hover:-translate-y-1 hover:brightness-105 transition-all duration-300">
            Experience The Difference
          </button>
        </div>
      </div>
    </section>
  );
}
